import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Instance axios configurée
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Service pour les villas
export const villasService = {
  // Récupérer la liste des villas avec filtres
  getVillas: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.zone) params.append('zone', filters.zone);
      if (filters.city) params.append('city', filters.city);
      if (filters.country) params.append('country', filters.country);
      if (filters.min_bedrooms) params.append('min_bedrooms', filters.min_bedrooms);
      if (filters.max_bedrooms) params.append('max_bedrooms', filters.max_bedrooms);
      if (filters.min_pax) params.append('min_pax', filters.min_pax);
      if (filters.limit) params.append('limit', filters.limit);
      if (filters.offset) params.append('offset', filters.offset);

      const response = await api.get(`/villas?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching villas:', error);
      throw error;
    }
  },

  // Récupérer les détails d'une villa
  getVillaById: async (id) => {
    try {
      const response = await api.get(`/villas/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching villa ${id}:`, error);
      throw error;
    }
  },

  // Récupérer les statistiques
  getStatistics: async () => {
    try {
      const response = await api.get('/statistics');
      return response.data;
    } catch (error) {
      console.error('Error fetching statistics:', error);
      throw error;
    }
  },

  // Récupérer les disponibilités d'une villa via l'API Villanovo
  getVillaAvailability: async (id) => {
    try {
      const response = await api.get(`/villas/${id}/availability`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching availability for villa ${id}:`, error);
      throw error;
    }
  },
};

// Service pour les règles de filtrage
export const filteringRulesService = {
  // Récupérer toutes les règles
  getRules: async () => {
    try {
      const response = await api.get('/filtering-rules');
      return response.data;
    } catch (error) {
      console.error('Error fetching filtering rules:', error);
      throw error;
    }
  },

  // Créer une nouvelle règle
  createRule: async (ruleData) => {
    try {
      const response = await api.post('/filtering-rules', ruleData);
      return response.data;
    } catch (error) {
      console.error('Error creating filtering rule:', error);
      throw error;
    }
  },

  // Mettre à jour une règle
  updateRule: async (id, ruleData) => {
    try {
      const response = await api.put(`/filtering-rules/${id}`, ruleData);
      return response.data;
    } catch (error) {
      console.error('Error updating filtering rule:', error);
      throw error;
    }
  },

  // Activer/désactiver une règle
  toggleRule: async (id) => {
    try {
      const response = await api.patch(`/filtering-rules/${id}/toggle`);
      return response.data;
    } catch (error) {
      console.error('Error toggling filtering rule:', error);
      throw error;
    }
  },

  // Supprimer une règle
  deleteRule: async (id) => {
    try {
      const response = await api.delete(`/filtering-rules/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting filtering rule:', error);
      throw error;
    }
  },

  // Récupérer les statistiques
  getStats: async () => {
    try {
      const response = await api.get('/filtering-rules/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching filtering stats:', error);
      throw error;
    }
  },

  // Récupérer les destinations disponibles depuis la BDD
  getDestinations: async (applyExclusions = true) => {
    try {
      const response = await api.get('/destinations', {
        params: { apply_exclusions: applyExclusions ? 'true' : 'false' }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching destinations:', error);
      throw error;
    }
  },
};

export default api;

